import { useState } from "react";
import { groupBy } from "../../../../utils";

export function TagSelector({
  tags,
  setTags,
  removeTag,
}: {
  tags: { id: string; salesforce_id: string; value: string }[];
  setTags: (
    tags: { id: string; salesforce_id: string; value: string }[]
  ) => void;
  removeTag: (tag: {
    id: string;
    salesforce_id: string;
    value: string;
  }) => void;
}) {
  const grouped = groupBy(tags, "salesforce_id");
  const keys = Object.keys(grouped);

  const [newTag, setNewTag] = useState("");

  function handleSetTag(tag: {
    id: string;
    salesforce_id: string;
    value: string;
  }) {
    const filtered = tags.filter((x) => x.id !== tag.id);
    setTags([...filtered, tag]);
  }

  return (
    <div>
      <div>
        {keys.map(function (x) {
          return (
            <div className="border-b w-full p-4">
              <div className="w-full flex flex-wrap">
                {grouped[x].map(function (
                  tag: {
                    id: string;
                    salesforce_id: string;
                    value: string;
                  },
                  key: number
                ) {
                  return (
                    <div className="border m-2 p-2 rounded" key={key}>
                      <button
                        className="flex flex-row justify-between"
                        onClick={() => removeTag(tag)}
                      >
                        <div className="flex flex-col text-left mr-4">
                          <p className="text-xs">{tag.salesforce_id}</p>
                          <p className="text-xs">{tag.value}</p>
                        </div>
                        <p className="underline">X</p>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="w-full flex justify-end items-center">
        <div className="flex flex-row items-center space-x-4 h-12 p-2">
          <input
            type="text"
            name="tag"
            id="tag"
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="School_University of Florida"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
          />
        </div>
        <div className="m-2">
          <button
            onClick={() =>
              handleSetTag({
                id: newTag,
                salesforce_id: "all",
                value: newTag,
              })
            }
            className="bg-black px-4 py-2 text-white my-4 mr-4"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
